import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { enforcesPasswordChange } from '../utils/roles';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, mustChangePassword, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force a first-login password change for staff/operator/customer accounts
  // (created with a temp password). Legacy KDU guests (Attendee/Delegate) are
  // exempt — they log in with a ticket number and the forced flow caused
  // lockouts, so /change-password stays voluntary for them.
  if (
    mustChangePassword &&
    enforcesPasswordChange(user?.role) &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
